function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const togglerLoader = (flag, selector) => {
  const loader = selector ? document.querySelector(selector) : document.querySelector('[data-loader]');
  if (!loader) return;
  if (flag) return loader.classList.remove('hidden');
  loader.classList.add('hidden');
}

const getJsonParse = (attrStr) => {
  let arr = [];
  const strArr = attrStr ? JSON.parse(attrStr) : null;
  if (!strArr) return arr = null;
  strArr.forEach(selector => arr.push(document.querySelector(selector)));
  return arr;
}

const sectionArrRender = (secArr, response) => {
  secArr.forEach(section => {
    const html = new DOMParser().parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
    if (!html) return; // Skip if element not found
    section.selectors.forEach(selector => {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.outerHTML = sourceElement.outerHTML;
      }
    });
  });
}

// Helper function to refresh and open cart drawer
const refreshAndOpenCartDrawer = () => {
  if (typeof refreshCartJS === 'function') {
    // Use existing refreshCartJS if available
    refreshCartJS();
    return;
  }

  // Fallback: Use native fetch
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateCartIconDirectly(cart.item_count || 0);
      const cartSlide = document.querySelector('cart-slide');
      if (cartSlide) {
        cartSlide.refreshCart?.();
        if (cartSlide.toggleCart && !cartSlide.classList.contains('active')) {
          cartSlide.toggleCart();
        }
      }
      // Dispatch cart update event
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
    })
    .catch(() => { });
}

const fetchAtc = (sections, config, element, loaderSelector) => {
  this.error = true;
  const btn = element?.querySelector?.('button[name="add"]');
  const loader = btn?.querySelector?.('.submit_add_cart_loader');
  if (loader) loader.classList.add('active');
  if (btn) btn.disabled = true;
  togglerLoader(true, loaderSelector);
  atcError(null, element, false);
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async (response) => {
      if (!response.sections) return atcError(response, element, true);
      this.error = false;
      sectionArrRender(sections, response);
      if (window.LuffCartOffers) await window.LuffCartOffers.reconcile();
      refreshAndOpenCartDrawer();
    })
    .catch((e) => {
      console.log(e);
      throw e;
    })
    .finally(() => {
      const _btn = element?.querySelector?.('button[name="add"]');
      const _loader = _btn?.querySelector?.('.submit_add_cart_loader');
      if (_loader) _loader.classList.remove('active');
      // Always re-enable the button after request completes
      if (_btn) {
        _btn.disabled = false;
        _btn.removeAttribute('disabled');
      }
      resetQty(element.dataset.form);
      togglerLoader(false, loaderSelector);
      if (!this.error) {
        if (element.dataset.redirect) return window.location.href = element.dataset.redirect;
        if (element.dataset.modal === 'true') {
          const drawerToggler = document.querySelector(element.dataset.modalRef);
          if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
        if (element.recipientForm) element.recipientForm.resetRecipientForm();
      }
    }
    );
}

const resetQty = (elem) => {
  if (!elem) return;
  const form = document.querySelector(elem);
  if (!form) return;
  const qtyField = form.quantity;
  if (!qtyField || qtyField.min == null || qtyField.min === '') return;
  qtyField.value = parseFloat(qtyField.min);
  qtyField.dispatchEvent(new Event('input'));
}

const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector, loaderSelector, checkBundle = false) => {
  const json = document.querySelector(jsonSelector);
  if (!json) return;
  const data = JSON.parse(json.textContent);
  const variants = data.variants;
  this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
  setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
  document.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variantId: this.currentVariant?.id } }));
  if (!this.currentVariant) return;
  const mediaId = (this.currentVariant.featured_media && this.currentVariant.featured_media.id) || this.currentVariant.featured_image;
  if (mediaId) setGallery(mediaId, gallerySelectors, renderMedia, templateSelector);
  renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector, loaderSelector);
}

const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
  const forms = getJsonParse(formElems);
  forms.forEach(form => {
    if (!form) return;
    const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
    if (!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
    toggleAvail(true, renderElems, parentElem);
    const input = form.querySelector('[name="id"]');
    input.value = variant.id;
    if (!atcBtn) return;
    const textContainer = atcBtn.querySelector('[data-atc-text]');
    if (variant.available) {
      textContainer.innerText = textContainer.dataset.textAvail;
      atcBtn.removeAttribute('disabled');
      atcBtn.classList.remove('--disabled');
      return;
    }
    textContainer.innerText = textContainer.dataset.textSold;
    atcBtn.setAttribute('disabled', '');
    atcBtn.classList.add('--disabled');
  });
}

const toggleAvail = (flag, selectors, parent, btn) => {
  const arr = JSON.parse(selectors);
  const parentElem = document.querySelector(parent);
  arr.forEach(selector => {
    const element = parentElem.querySelector(selector);
    if (!element) return;
    flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
  });
  if (!btn) return;
  const textContainer = btn.querySelector('[data-atc-text]');
  textContainer.innerText = textContainer.dataset.textUnavail;
  btn.setAttribute('disabled', '');
}

const setGallery = (imageId, galleries, render, template) => {
  const arr = JSON.parse(galleries);
  if (!arr) return;
  if (render) {
    const templateElem = document.querySelector(template);
    const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
    const imageContainer = document.querySelector(arr[0]);
    var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
    var newOpacity = (currentOpacity === 1) ? 0 : 1;
    imageContainer.style.transition = 'opacity 0.3s ease';
    imageContainer.style.opacity = newOpacity;
    imageContainer.classList.remove('.imageContainer');
    setTimeout(() => {
      imageContainer.innerHTML = templateElement.outerHTML;
      setTimeout(() => {
        imageContainer.style.opacity = 1;
      }, 0);
    }, 500);
    return
  }
  arr.forEach(gallery => {
    const elements = document.querySelectorAll(gallery);
    elements.forEach(gal => {
      if (!gal) return;
      switch (gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (!items.length) return;
          const activeIndex = items.findIndex(item => String(item.dataset.mediaId) === String(imageId));
          if (activeIndex === -1 || activeIndex === 0) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          if (!splide?.Components?.Slides) return;
          const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          if (slide && slide[0] != null) splide.go(slide[0].index);
          break;
      }
    });
  });
}

const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
  togglerLoader(true, loaderSelector);
  fetch(`${url}?variant=${id}&section_id=${section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const parentElement = document.querySelector(parent);
      const arr = JSON.parse(elems);
      arr.forEach(selector => {
        const element = parentElement.querySelector(selector);
        if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
      });
    })
    .catch((e) => {
      console.error(e);
      throw e;
    })
    .finally(() => {
      if (updateUrl === 'true') {
        window.history.replaceState({}, '', `${url}?variant=${id}`);
      } else if (updateUrl === 'variant-id') {
        const u = new URL(window.location.href);
        u.searchParams.set('variant-id', id);
        window.history.replaceState({}, '', u.toString());
      }
      if (focusSelector) {
        const focusParent = document.querySelector(focusSelector);
        trapFocus(focusParent.content ? focusParent.content : focusParent);
      }
      togglerLoader(false, loaderSelector);
    }
    );
}

const atcError = (response, elem, flag) => {
  const errElem = elem?.dataset?.errorSelector ? document.querySelector(elem.dataset.errorSelector) : null;
  const errSpan = errElem?.querySelector('[data-error]');
  const recepForm = elem?.form?.querySelector?.('recipient-form');

  if (!flag) {
    if (errElem) errElem.classList.add('hidden');
    if (errSpan) errSpan.innerText = '';
    if (recepForm) recepForm.clearErrorMessage();
    // Clear addon errors
    clearAddonErrors();
    return;
  }

  if (recepForm && response?.errors) recepForm.displayErrorMessage(null, response.errors);

  // Check if error is related to sold-out addon
  const errorMessage = response?.description || response?.message || '';
  const isSoldOutError = errorMessage.toLowerCase().includes('sold out') ||
    errorMessage.toLowerCase().includes('out of stock') ||
    errorMessage.toLowerCase().includes('not available');

  if (isSoldOutError && errorMessage.toLowerCase().includes('addon')) {
    // Show error below addons section
    showAddonError(errorMessage);
    scrollToAddons();
  } else if (typeof response?.description !== 'object' && errElem && errSpan) {
    errElem.classList.remove('hidden');
    errSpan.innerText = response?.description || '';
  }

  if (elem?.dataset?.form) resetQty(elem.dataset.form);
}

// Show error message below addons section
const showAddonError = (message) => {
  // Find or create addon error container
  const addonsSection = document.querySelector('.product-addons') ||
    document.querySelector('[data-product-addons]');

  if (!addonsSection) return;

  let errorContainer = addonsSection.querySelector('.product-addons__error');

  if (!errorContainer) {
    errorContainer = document.createElement('div');
    errorContainer.className = 'product-addons__error';
    errorContainer.style.cssText = `
      background: #fee;
      color: #c00;
      padding: 12px 16px;
      margin: 12px 0;
      border-radius: 4px;
      border-left: 4px solid #c00;
      font-size: 14px;
      display: none;
    `;
    addonsSection.appendChild(errorContainer);
  }

  errorContainer.textContent = message;
  errorContainer.style.display = 'block';

  // Auto-hide after 8 seconds
  setTimeout(() => {
    if (errorContainer) {
      errorContainer.style.display = 'none';
    }
  }, 8000);
}

// Clear addon errors
const clearAddonErrors = () => {
  const errorContainers = document.querySelectorAll('.product-addons__error');
  errorContainers.forEach(container => {
    container.style.display = 'none';
  });
}

// Scroll to addons section
const scrollToAddons = () => {
  const addonsSection = document.querySelector('.product-addons') ||
    document.querySelector('[data-product-addons]');

  if (addonsSection) {
    // Smooth scroll to addons section with offset for header
    const headerOffset = 100; // Adjust based on your header height
    const elementPosition = addonsSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

class VariantPills extends HTMLElement {
  constructor() {
    super();

    this.variantChange = this.onInputChange.bind(this);
    this.addEventListener('change', this.variantChange);
    this.sizeButtonClick = this.onSizeButtonClick.bind(this);
  }

  connectedCallback() {
    // Add click listeners to size buttons
    this.setupSizeButtons();
  }

  setupSizeButtons() {
    const sizeButtons = this.querySelectorAll('.size-button-list .size-button');
    sizeButtons.forEach(button => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', this.sizeButtonClick);
    });
  }

  onSizeButtonClick(event) {
    const button = event.currentTarget;
    const value = button.dataset.size;
    if (!value) return;

    // Update active state
    const buttonList = button.closest('.size-button-list');
    if (buttonList) {
      buttonList.querySelectorAll('.size-button').forEach(b => b.classList.remove('active'));
      button.classList.add('active');
    }

    // Trigger variant change
    this.setVariantOptions(value);
  }

  onInputChange() {
    const input = this.querySelector('input[type="radio"]:checked');
    if (input) {
      this.setVariantOptions(input.value);
    }
  }

  setVariantOptions(value) {
    const parent = document.querySelector(this.dataset.parent);
    const mainParent = document.querySelector(this.dataset.mainParent);
    const errElem = document.querySelector(this.dataset.errorSelector);
    if (!parent) return;
    if (mainParent && mainParent.hasAttribute('data-bundle-included')) {
      const bundleCalculator = document.querySelector('bundle-calculator');
      mainParent.removeAttribute('data-bundle-included');
      bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
    }
    if (errElem) errElem.classList.add('hidden');
    const currentSet = JSON.parse(this.dataset.currentSet);
    const index = parseInt(this.dataset.optionIndex);
    currentSet[index] = value;
    // Update all variant-pills and variant-dropdowns in the parent
    const pills = parent.querySelectorAll('variant-pills');
    pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
    const dropdowns = parent.querySelectorAll('variant-dropdown');
    dropdowns.forEach(dropdown => dropdown.setAttribute('data-current-set', JSON.stringify(currentSet)));
    this.setOptions(pills, currentSet);
    let availableSet = null;
    if (this.dataset.checkSets === 'true') {
      const sets = JSON.parse(this.dataset.availableSets);
      const checkSet = (val) => {
        if (!val || !Array.isArray(sets)) return null;
        return sets.find(set => set.includes(val));
      };
      availableSet = checkSet(value);
    }
    onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null, this.dataset.loader ? this.dataset.loader : null, this.dataset.bundle === 'true' ? true : false);

    // Update .active-color for color_circles_lbtext when this pills block is inside it
    const optionBlock = this.closest('.option-block');
    if (optionBlock) {
      const idx = this.dataset.optionIndex;
      const activeSpan = optionBlock.querySelector('.active-color[data-option-index="' + idx + '"]');
      if (activeSpan) activeSpan.textContent = value;
    }

    // Re-setup size buttons after variant change (in case DOM was updated)
    setTimeout(() => {
      this.setupSizeButtons();
    }, 100);
  }

  setOptions(elems, set) {
    const json = document.querySelector(this.dataset.jsonSelector);
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
    elems.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
      // Get previous option value - check for radio input first, then size button
      let previousOptionSelected = null;
      const previousRadio = elems[index - 1].querySelector('input[type="radio"]:checked');
      if (previousRadio) {
        previousOptionSelected = previousRadio.value;
      } else {
        // Check for active size button
        const previousSizeButton = elems[index - 1].querySelector('.size-button.active');
        if (previousSizeButton) {
          previousOptionSelected = previousSizeButton.dataset.size;
        } else {
          // Fallback to currentSet value
          previousOptionSelected = set[index - 1];
        }
      }
      if (!previousOptionSelected) return;

      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(elem => {
      const label = elem.nextElementSibling;
      const labelText = label.querySelector('[data-variant-status-text]');
      if (listOfAvailableOptions.includes(elem.getAttribute('value'))) {
        elem.classList.remove('disabled');
        labelText.classList.add('hidden'), labelText.classList.remove('visually-hidden');
        return;
      }
      elem.classList.add('disabled');
      labelText.classList.remove('hidden'), labelText.classList.add('visually-hidden');
    });
  }
}

class PacSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const mainProductSection = this.closest('.main-product-section');
    const productForm = this.closest('form.form_add_cartp');
    const qtyInput = (root) =>
      root?.querySelector('quantity-inputs input[name="quantity"]') || root?.querySelector('quantity-input input[name="quantity"]');
    if (mainProductSection) {
      this.quantityInput = qtyInput(mainProductSection);
      this.quantityWrapper = mainProductSection.querySelector('quantity-inputs');
    } else if (productForm) {
      this.quantityInput = qtyInput(productForm);
      this.quantityWrapper = productForm.querySelector('quantity-inputs');
    } else {
      this.quantityInput = qtyInput(document);
      this.quantityWrapper = document.querySelector('quantity-inputs');
    }

    if (this.quantityWrapper) {
      this.quantityWrapper.style.display = 'none';
    }

    this.addEventListener('click', this.handleClick.bind(this));

    // При загрузке активный пак
    const defaultActive = this.querySelector('.pack.active');
    if (defaultActive) {
      this.setQuantityFromPack(defaultActive);
    }
  }

  handleClick(event) {
    const clickedPack = event.target.closest('.pack');
    if (!clickedPack || !this.contains(clickedPack)) return;

    this.querySelectorAll('.pack').forEach(pack => {
      pack.classList.remove('active');
    });

    clickedPack.classList.add('active');
    this.setQuantityFromPack(clickedPack);
    // Вызываем кастомное событие (опционально)
    this.dispatchEvent(new CustomEvent('pack:change', {
      detail: {
        id: clickedPack.dataset.packId,
        quantity: clickedPack.querySelector('[data-packquntity]')?.dataset.packquntity
      },
      bubbles: true
    }));
  }

  setQuantityFromPack(packElement) {
    const quantityElement = packElement.querySelector('[data-packquntity]');
    const quantity = quantityElement?.dataset.packquntity;
    const mainProductSection = this.closest('.main-product-section');
    const productForm = this.closest('form.form_add_cartp');
    const root = mainProductSection || productForm || document;
    this.quantityInput = root.querySelector('quantity-inputs input[name="quantity"]') || root.querySelector('quantity-input input[name="quantity"]');
    if (this.quantityInput && quantity) {
      const qtyValue = parseInt(quantity, 10);
      if (!isNaN(qtyValue) && qtyValue > 0) {
        this.quantityInput.value = qtyValue;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    const onButtonClick = (event) => {
      event.preventDefault();
      const btn = event.target.closest('button');
      if (!btn) return;
      const previousValue = this.input.value;
      (btn.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    const setBtnStatus = (type, value) => {
      const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
      const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
      switch (type) {
        case 'min':
          btn.classList.toggle('disabled', value <= currVal);
          btn.toggleAttribute('disabled', value <= currVal);
          break;
        case 'max':
          btn.classList.toggle('disabled', value >= currVal);
          btn.toggleAttribute('disabled', value >= currVal);
          break;
        default:
          console.log('no button found');
          break;
      }
    }

    const setSubtotals = (qty, elem) => {
      const total = qty * parseInt(this.dataset.variantPrice);
      elem.innerHTML = Shopify.formatMoney(total, window.money_format);
    }

    const onInputChange = () => {
      const value = parseInt(this.input.value);
      const qtySubtotal = this.querySelector('[data-qty-subtotal]');
      (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
      if (!qtySubtotal) return;
      setSubtotals(value, qtySubtotal);
    }

    const setListeners = () => {
      this.changeEvent = new Event('input', { bubbles: true });
      this.inputChange = onInputChange.bind(this);
      this.buttonClick = onButtonClick.bind(this);
      this.input.addEventListener('input', this.inputChange);
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
    }

    const initialize = () => {
      this.input = this.querySelector('input');
      if (!this.input) return;
      setListeners();
    }
    initialize();
  }
}

class GiftBlock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const section = this.closest('.main-product-section');
    const form = section?.querySelector('form[data-type="add-to-cart-form"]') || section?.querySelector('form input[name="id"]')?.closest('form');
    this.input = form?.quantity || section?.querySelector('input[name="quantity"]') || section?.querySelector('quantity-input input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    this.observeInputChanges();
    this.observeVariantChange();
    this.observePackChanges();
    this.checkGifts();
  }

  observeInputChanges() {
    if (!this.input) return;
    this.input.addEventListener('input', () => this.checkGifts());
    this.input.addEventListener('change', () => this.checkGifts());
  }

  observeVariantChange() {
    document.addEventListener('variant:change', () => this.checkGifts());
    const section = this.closest('.main-product-section');
    const variantInput = section?.querySelector('form input[name="id"]') || document.querySelector('#product-variant-id');
    if (variantInput) {
      variantInput.addEventListener('change', () => this.checkGifts());
    }
  }

  observePackChanges() {
    const section = this.closest('.main-product-section');
    const pacSection = section?.querySelector('pac-section') || document.querySelector('pac-section');
    if (pacSection) {
      pacSection.addEventListener('pack:change', () => this.checkGifts());
    }
  }

  async fetchCartData() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Failed to fetch cart');
      const data = await res.json();
      return {
        quantity: data.items.reduce((total, item) => total + item.quantity, 0),
        total_price: data.items.reduce((total, item) => total + item.quantity * item.final_price, 0) // accurate item pricing
      };
    } catch (e) {
      return { quantity: 0, total_price: 0 };
    }
  }

  getSelectedVariantPriceFromJson() {
    const section = this.closest('.main-product-section');
    const variantIdEl = section?.querySelector('form input[name="id"]') || document.querySelector('#product-variant-id');
    const jsonScript = document.querySelector('#json_prod_var');
    if (!variantIdEl || !jsonScript) return 0;

    try {
      const variantId = parseInt(variantIdEl.value, 10);
      const variants = JSON.parse(jsonScript.textContent);
      const selected = Array.isArray(variants) ? variants.find(v => v.id === variantId) : null;
      return selected && (selected.price != null) ? Number(selected.price) : 0;
    } catch (e) {
      return 0;
    }
  }

  async checkGifts() {
    const gifts = this.querySelectorAll('.gift');
    const cart = await this.fetchCartData();
    const section = this.closest('.main-product-section');
    const packEl = section?.querySelector('pac-section .pack.active [data-packquntity]');
    let localQty = parseInt(this.input?.value || '0', 10);
    if (packEl?.dataset?.packquntity) {
      const q = parseInt(packEl.dataset.packquntity, 10);
      if (!isNaN(q) && q > 0) localQty = q;
    } else {
      const form = section?.querySelector('form[data-type="add-to-cart-form"]') || section?.querySelector('form input[name="id"]')?.closest('form');
      const v = form?.quantity?.value;
      if (v != null && v !== '') localQty = parseInt(v, 10) || 1;
    }
    const selectedPrice = this.getSelectedVariantPriceFromJson();
    const localTotal = localQty * selectedPrice;
    const combinedQty = localQty + cart.quantity;
    const combinedTotal = localTotal + cart.total_price;

    gifts.forEach(gift => {
      const giftId = gift.dataset.giftid;
      if (!giftId || giftId === '0') return this.lockGift(gift);

      const area = gift.dataset.giftarea;
      const rule = gift.dataset.unlockrulle || 'price';
      const qtyUnlock = parseInt(gift.dataset.qtyunlock || '0', 10);
      const priceUnlock = parseInt(gift.dataset.priceunlock || '0', 10);

      let isUnlocked = false;

      if (area === 'global') {
        if (rule === 'quntity') {
          isUnlocked = qtyUnlock > 0 && combinedQty >= qtyUnlock;
        } else if (rule === 'price') {
          isUnlocked = priceUnlock > 0 && combinedTotal >= priceUnlock;
        }
      } else if (area === 'local') {
        if (rule === 'quntity') {
          isUnlocked = qtyUnlock > 0 && localQty >= qtyUnlock;
        } else if (rule === 'price') {
          isUnlocked = priceUnlock > 0 && localTotal >= priceUnlock;
        }
      }

      if (isUnlocked) {
        this.unlockGift(gift);
      } else {
        this.lockGift(gift);
      }
    });
  }
  unlockGift(gift) {
    gift.dataset.locked = 'false';
    const customImg = gift.dataset.giftimg?.trim();
    const productImg = gift.dataset.giftproductimg?.trim();

    // Check if URL is valid (not empty and has actual path before query params)
    const isValidUrl = (url) => {
      if (!url || url === '') return false;
      // Check for Liquid error messages
      if (url.includes('Liquid error') || url.includes('invalid url input')) return false;
      // Shopify returns URLs like "?width=400" when no image exists
      if (url.startsWith('?')) return false;
      // Check if there's actual content before the query params
      const pathPart = url.split('?')[0];
      return pathPart && pathPart.length > 0;
    };

    const imgSrc = isValidUrl(customImg) ? customImg :
      isValidUrl(productImg) ? productImg : null;

    const wrapper = gift.querySelector('.gift-image');

    if (imgSrc && wrapper) {
      // Add onerror handler to show placeholder if image fails to load
      wrapper.innerHTML = `<img src="${imgSrc}" alt="Gift" onerror="this.style.display='none'; this.parentElement.innerHTML='<svg width=\\'60\\' height=\\'60\\' viewBox=\\'0 0 60 60\\' fill=\\'none\\'><rect width=\\'60\\' height=\\'60\\' fill=\\'#f0f0f0\\'/><path d=\\'M30 20v20M20 30h20\\' stroke=\\'#999\\' stroke-width=\\'2\\'/></svg><div style=\\'color: #666; font-size: 12px; margin-top: 8px;\\'>Gift Image</div>';">`;
    } else if (wrapper) {
      // No valid image URL, show placeholder
      wrapper.innerHTML = `<svg width="60" height="60" viewBox="0 0 60 60" fill="none"><rect width="60" height="60" fill="#f0f0f0"/><path d="M30 20v20M20 30h20" stroke="#999" stroke-width="2"/></svg><div style="color: #666; font-size: 12px; margin-top: 8px;">Gift Image</div>`;
    }
  }


  lockGift(gift) {
    gift.dataset.locked = 'true';
    const wrapper = gift.querySelector('.gift-image');
    const maney = gift.dataset.priceunlock;
    const customLockImg = this.dataset.lockimg?.trim();

    if (wrapper) {
      if (customLockImg && customLockImg !== '') {
        // Use custom lock image
        wrapper.innerHTML = this.lockCustomImage(customLockImg, maney);
      } else {
        // Use default SVG lock icon
        wrapper.innerHTML = this.lockSVG(maney);
      }
    }
  }

  lockCustomImage(imgSrc, maney) {
    return `<img src="${imgSrc}" alt="Locked" style="max-width: 100px; max-height: 100px;">
            <div>Spend ${Shopify.formatMoney(maney, window.money_format || '{{amount}}')} to unlock</div>`;
  }

  lockSVG(maney) {
    return `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="23.5" fill="white" stroke="black"/>
            <path d="M30.75 34.3184H17.25C16.6533 34.3184 16.081 34.0813 15.659 33.6593C15.2371 33.2374 15 32.6651 15 32.0684V23.8184C15 23.2216 15.2371 22.6493 15.659 22.2274C16.081 21.8054 16.6533 21.5684 17.25 21.5684H30.75C31.3467 21.5684 31.919 21.8054 32.341 22.2274C32.7629 22.6493 33 23.2216 33 23.8184V32.0684C33 32.6651 32.7629 33.2374 32.341 33.6593C31.919 34.0813 31.3467 34.3184 30.75 34.3184ZM17.25 23.0684C17.0511 23.0684 16.8603 23.1474 16.7197 23.288C16.579 23.4287 16.5 23.6194 16.5 23.8184V32.0684C16.5 32.2673 16.579 32.458 16.7197 32.5987C16.8603 32.7393 17.0511 32.8184 17.25 32.8184H30.75C30.9489 32.8184 31.1397 32.7393 31.2803 32.5987C31.421 32.458 31.5 32.2673 31.5 32.0684V23.8184C31.5 23.6194 31.421 23.4287 31.2803 23.288C31.1397 23.1474 30.9489 23.0684 30.75 23.0684H17.25Z" fill="#101820"/>
            <path d="M30 23.0684H18C17.8011 23.0684 17.6103 22.9893 17.4697 22.8487C17.329 22.708 17.25 22.5173 17.25 22.3184V17.8184C17.25 16.2271 17.8821 14.7009 19.0074 13.5757C20.1326 12.4505 21.6587 11.8184 23.25 11.8184H24.75C26.3413 11.8184 27.8674 12.4505 28.9926 13.5757C30.1179 14.7009 30.75 16.2271 30.75 17.8184V22.3184C30.75 22.5173 30.671 22.708 30.5303 22.8487C30.3897 22.9893 30.1989 23.0684 30 23.0684ZM18.75 21.5684H29.25V17.8184C29.25 16.6249 28.7759 15.4803 27.932 14.6364C27.0881 13.7925 25.9435 13.3184 24.75 13.3184H23.25C22.0565 13.3184 20.9119 13.7925 20.068 14.6364C19.2241 15.4803 18.75 16.6249 18.75 17.8184V21.5684Z" fill="#101820"/>
            <path d="M24 28.3184C23.7033 28.3184 23.4133 28.2304 23.1666 28.0656C22.92 27.9007 22.7277 27.6665 22.6142 27.3924C22.5006 27.1183 22.4709 26.8167 22.5288 26.5257C22.5867 26.2348 22.7296 25.9675 22.9393 25.7577C23.1491 25.5479 23.4164 25.4051 23.7074 25.3472C23.9983 25.2893 24.2999 25.319 24.574 25.4325C24.8481 25.5461 25.0824 25.7383 25.2472 25.985C25.412 26.2317 25.5 26.5217 25.5 26.8184C25.5 27.2162 25.342 27.5977 25.0607 27.879C24.7794 28.1603 24.3978 28.3184 24 28.3184Z" fill="#101820"/>
            <path d="M24.75 27.5684H23.25V30.5684H24.75V27.5684Z" fill="#101820"/>
          </svg>
          <div>Spend ${Shopify.formatMoney(maney, window.money_format || '{{amount}}')} to unlock</div>
          `;
  }
}

// Helper function to update cart icon directly (fix for cart icon update issue)
function updateCartIconDirectly(itemCount) {
  const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
  const headerCartCount = document.querySelector('.header__cart-count');
  const cartLinkBubble = document.querySelector('.cart-link__bubble');

  if (cartCountBubble) {
    if (itemCount > 0 && itemCount < 100) {
      cartCountBubble.textContent = itemCount;
    } else if (itemCount >= 100) {
      cartCountBubble.textContent = '99+';
    } else {
      cartCountBubble.textContent = '';
    }
  }

  if (headerCartCount) {
    headerCartCount.textContent = itemCount || 0;
  }

  if (cartLinkBubble) {
    if (itemCount > 0) {
      cartLinkBubble.classList.add('cart-link__bubble--visible');
    } else {
      cartLinkBubble.classList.remove('cart-link__bubble--visible');
    }
  }
}

/** Packs + form quantity: use pac-section active pack qty when present, else form quantity. */
function getAtcMainQty(form) {
  const section = form?.closest('.main-product-section');
  const packEl = section?.querySelector('pac-section .pack.active [data-packquntity]');
  if (packEl?.dataset?.packquntity) {
    const q = parseInt(packEl.dataset.packquntity, 10);
    if (!isNaN(q) && q > 0) return q;
  }
  const v = form?.quantity?.value;
  return (v != null && v !== '') ? (parseInt(v, 10) || 1) : 1;
}

/** Selected addon variant ids (excluding placeholders). */
function getAtcAddonIds() {
  const ids = [];
  document.querySelectorAll('.product-addons__toggle:checked:not(:disabled)').forEach((cb) => {
    const item = cb.closest('.product-addons__item');
    if (item?.classList.contains('product-addons__item--placeholder')) return;
    const id = item?.dataset?.variantId;
    if (id) ids.push(id);
  });
  return ids;
}

/** Unlocked gift variant ids in the form's product section. */
function getAtcGiftIds(form) {
  if (form?.querySelector('atc-submit[data-cart-offer]')) return [];
  const section = form?.closest('.main-product-section');
  const ids = [];
  section?.querySelectorAll('.gift[data-locked="false"]')?.forEach((el) => {
    const id = el.dataset?.giftid;
    if (id && id !== '0') ids.push(id);
  });
  return ids;
}

class AtcSubmit extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = document.querySelector(this.dataset.form);
    if (!this.form) return;
    this.recipientForm = this.form.querySelector('recipient-form');
    this.submit = this.onAddToCart.bind(this);
    this.form.addEventListener('submit', this.submit);
  }

  onAddToCart(event) {
    event.preventDefault();
    this.error = false;
    const secArr = JSON.parse(this.dataset.sections);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const mainId = this.form.querySelector('[name="id"]')?.value;
    const mainQty = getAtcMainQty(this.form);
    const addonIds = getAtcAddonIds();
    const giftIds = getAtcGiftIds(this.form);
    const hasExtraItems = addonIds.length > 0 || giftIds.length > 0;
    let formData;
    if (hasExtraItems && mainId) {
      formData = new FormData();
      formData.append('items[][id]', mainId);
      formData.append('items[][quantity]', String(mainQty));
      addonIds.forEach((id) => { formData.append('items[][id]', id); formData.append('items[][quantity]', '1'); });
      giftIds.forEach((id) => { formData.append('items[][id]', id); formData.append('items[][quantity]', '1'); });
      formData.append('sections', secArr.map(s => s.id));
      formData.append('sections_url', window.location.pathname);
    } else {
      formData = new FormData(this.form);
      formData.set('quantity', String(mainQty));
      formData.append('sections', secArr.map(s => s.id));
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;
    fetchAtc(secArr, config, this, this.dataset.loader);
  }
}

class VariantDropdown extends HTMLElement {
  constructor() {
    super();
    this.connected = false;
  }

  connectedCallback() {
    if (this.connected) return;
    this.connected = true;

    const select = this.querySelector('.custom-select');
    if (!select) return;

    const trigger = select.querySelector('.select-trigger');
    const options = select.querySelectorAll('.option-value');

    if (!trigger || !options.length) return;

    // Preselect initial value from currentSet
    const currentSet = JSON.parse(this.dataset.currentSet);
    const index = parseInt(this.dataset.optionIndex);
    const currentValue = currentSet[index];
    if (currentValue) {
      const preselectedOption = Array.from(options).find(opt => opt.dataset.value === currentValue);
      if (preselectedOption) {
        this.updateTriggerDisplay(trigger, preselectedOption);
        preselectedOption.classList.add('selected');
      }
    }

    // Toggle dropdown on trigger click
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      select.classList.toggle('open');
    });

    // Handle option selection
    options.forEach((opt) => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        const value = opt.dataset.value;
        if (!value) return;

        // Update trigger display BEFORE closing dropdown to ensure proper rendering
        this.updateTriggerDisplay(trigger, opt);

        select.classList.remove('open');

        options.forEach((o) => o.classList.remove('selected'));
        opt.classList.add('selected');

        // Update variant using same logic as VariantPills
        this.setVariantOptions(value);
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!select.contains(e.target)) {
        select.classList.remove('open');
      }
    });
  }

  updateTriggerDisplay(trigger, option) {
    if (!trigger || !option) return;

    // Clear existing content
    trigger.innerHTML = '';

    // Check if option has variant image
    const hasImage = option.dataset.hasImage === 'true';
    const imageUrl = option.dataset.imageUrl;
    const variantImageSwatch = option.querySelector('.variant-image-swatch');

    // Add variant image swatch if available
    if (hasImage && imageUrl) {
      const imageSwatch = document.createElement('span');
      imageSwatch.className = 'dropdown-swatch variant-image-swatch';
      imageSwatch.style.cssText = 'background-image: url(\'' + imageUrl + '\'); background-size: cover; background-position: center; background-repeat: no-repeat; display: inline-block; width: 20px; height: 20px; border-radius: 50%; vertical-align: middle; margin-right: 8px;';
      trigger.appendChild(imageSwatch);
    } else if (variantImageSwatch) {
      // Clone the existing variant image swatch if data attributes are not available
      const clonedSwatch = variantImageSwatch.cloneNode(true);
      trigger.appendChild(clonedSwatch);
    }

    // Get text content only - exclude swatch/icon elements
    let textContent = '';

    // Walk through child nodes and collect text
    for (let i = 0; i < option.childNodes.length; i++) {
      const node = option.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent.trim();
        if (text) {
          textContent += (textContent ? ' ' : '') + text;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Skip swatch and icon elements
        if (!node.classList.contains('dropdown-swatch') &&
          !node.classList.contains('variant-image-swatch') &&
          node.tagName !== 'I') {
          // Get text from this element (but not from nested swatches)
          const elementText = node.textContent.trim();
          if (elementText) {
            textContent += (textContent ? ' ' : '') + elementText;
          }
        }
      }
    }

    // Fallback: use dataset value if no text found
    if (!textContent || textContent.trim() === '') {
      textContent = option.dataset.value || option.textContent.trim() || '';
    }

    // Add text content
    if (textContent && textContent.trim() !== '') {
      const textNode = document.createTextNode(textContent.trim());
      trigger.appendChild(textNode);
    }
  }

  setVariantOptions(value) {
    const parent = document.querySelector(this.dataset.parent);
    const mainParent = document.querySelector(this.dataset.mainParent);
    const errElem = document.querySelector(this.dataset.errorSelector);

    if (!parent) return;

    if (mainParent && mainParent.hasAttribute('data-bundle-included')) {
      const bundleCalculator = document.querySelector('bundle-calculator');
      mainParent.removeAttribute('data-bundle-included');
      bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
    }

    if (errElem) errElem.classList.add('hidden');

    const currentSet = JSON.parse(this.dataset.currentSet);
    const index = parseInt(this.dataset.optionIndex);
    currentSet[index] = value;

    // Update data-current-set attribute
    this.setAttribute('data-current-set', JSON.stringify(currentSet));

    // Update other variant-pills and variant-dropdowns
    const pills = parent.querySelectorAll('variant-pills');
    pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));

    const dropdowns = parent.querySelectorAll('variant-dropdown');
    dropdowns.forEach(dropdown => dropdown.setAttribute('data-current-set', JSON.stringify(currentSet)));

    let availableSet = null;
    if (this.dataset.checkSets === 'true') {
      const sets = JSON.parse(this.dataset.availableSets);
      const checkSet = (val) => {
        if (!val || !Array.isArray(sets)) return null;
        return sets.find(set => set.includes(val));
      };
      availableSet = checkSet(value);
    }

    onVariantChange(
      this.dataset.jsonSelector,
      availableSet ? availableSet : currentSet,
      this.dataset.forms,
      this.dataset.renders,
      this.dataset.mainParent,
      this.dataset.galleries,
      this.dataset.sectionId,
      this.dataset.productUrl,
      this.dataset.updateUrl,
      this.dataset.focusSelector ? this.dataset.focusSelector : null,
      this.dataset.mediaTemplate === 'true' ? true : false,
      this.dataset.mediaTemplate === 'true' ? this.dataset.template : null,
      this.dataset.loader ? this.dataset.loader : null,
      this.dataset.bundle === 'true' ? true : false
    );
  }

  static get observedAttributes() {
    return ['data-current-set'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-current-set' && oldValue !== newValue && this.connected) {
      const currentSet = JSON.parse(newValue);
      const index = parseInt(this.dataset.optionIndex);
      const currentValue = currentSet[index];

      if (currentValue) {
        const select = this.querySelector('.custom-select');
        const trigger = select?.querySelector('.select-trigger');
        const options = select?.querySelectorAll('.option-value');

        if (trigger && options) {
          const selectedOption = Array.from(options).find(opt => opt.dataset.value === currentValue);
          if (selectedOption) {
            trigger.textContent = selectedOption.textContent.trim();
            options.forEach((o) => o.classList.remove('selected'));
            selectedOption.classList.add('selected');
          }
        }
      }
    }
  }
}

// Addon Script
(function () {
  function initAddonScript() {
    const addonForm = document.querySelector('form[action^="/cart"]');
    if (addonForm) {
      addonForm.addEventListener('submit', function (e) {
        const selectedAddons = document.querySelectorAll('.product-addons__toggle:checked:not(:disabled)');
        selectedAddons.forEach((checkbox) => {
          const addonItem = checkbox.closest('.product-addons__item');
          if (addonItem && addonItem.classList.contains('product-addons__item--placeholder')) {
            return;
          }
          const variantId = addonItem?.dataset.variantId;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[]';
          input.value = variantId;
          addonForm.appendChild(input);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddonScript);
  } else {
    initAddonScript();
  }
})();

// Sizechart Modal Script
(function () {
  function initSizechartModal() {
    const modal = document.getElementById('sizechart-modal');
    const modalContent = document.getElementById('sizechart-modal-content');
    const closeBtn = document.getElementById('sizechart-close');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (modal) modal.style.display = 'none';
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal) {
        modal.style.display = 'none';
      }
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (modalContent && !modalContent.contains(e.target)) {
          modal.style.display = 'none';
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizechartModal);
  } else {
    initSizechartModal();
  }
})();


document.addEventListener("DOMContentLoaded", (event) => {

  customElements.define('variant-pills', VariantPills);
  customElements.define('variant-dropdown', VariantDropdown);
  customElements.define('pac-section', PacSection);

  if (!customElements.get('gift-block')) customElements.define('gift-block', GiftBlock);
  if (!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

})
